/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Commandman1Inputs */



/**
* | output |
* | --- |
* | "Manual command" |
*
* @param {Br_History_Key_Commandman1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_commandman1 = /** @type {((inputs?: Br_History_Key_Commandman1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Commandman1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manual command")
	return /** @type {LocalizedString} */ ("Command manuelle")
});
export { br_history_key_commandman1 as "br_history_key_commandMan" }